"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppType = void 0;
var AppType;
(function (AppType) {
    AppType["GAMBLING"] = "gambling";
    AppType["FINANCES"] = "finances"; // do not change the order!
})(AppType = exports.AppType || (exports.AppType = {}));
